import { Box, Button } from '@mui/material'
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'

import { useHomeVisitLetterhead } from './useHomecare'

interface Props {
  yakurekiId: string
}

// 訪問のページの頭の帰り口。パンくずは字だけで押せないので、入ったページの中に置く。
// 患者に紐付かない旧い在宅の記録では出さない。
export const HomecareVisitBackLink = ({ yakurekiId }: Props) => {
  const navigate = useNavigate()
  const { data: letterhead } = useHomeVisitLetterhead(yakurekiId)
  if (!letterhead) return null
  const { patient } = letterhead
  return (
    <Box sx={{ mb: 1 }}>
      <Button
        size="small"
        startIcon={<ArrowBackIcon />}
        onClick={() => navigate(`/homecare/patients/${patient.id}`)}
      >
        {patient.name}
      </Button>
    </Box>
  )
}
